import actions from '../app-ui/app-ui-actions-creator';

export function kambiClientRendered() {
  return (dispatch) => {
    return dispatch(actions.kambiClientRendered());
  };
}

export function setIsMobileLook(value){
  return (dispatch) => {
    return dispatch(actions.setIsMobileLook(value));
  };
}

export function setDebugMode(value){
  return (dispatch) => {
    return dispatch(actions.setDebugMode(value));
  };
}

export function setNativeUXVersion(value){
  return (dispatch) => {
    return dispatch(actions.setNativeUXVersion(value));
  };
}
